//React And GLOBAL CSS
import React, { useEffect, useState } from 'react';
import GConf from './AssetsM/generalConf';
import LoadingBar from 'react-top-loading-bar'
import { toast, ToastContainer } from 'react-toastify';

// /*CSS*/
import 'bootstrap-icons/font/bootstrap-icons.css';
import './theme.css';
import "gridjs/dist/theme/mermaid.css";
import 'react-toastify/dist/ReactToastify.css';

//Router & Routes
import { BrowserRouter as Router,Routes,Route, Outlet} from "react-router-dom";
import { Navigate } from 'react-router-dom';

import NouveauxFacture from "./Interfaces/NFacture/nouveauxFacture";

//Mes Factures
import MesFactures from "./Interfaces/MFactures/mesFactures";
import FactureInfo from './Interfaces/MFactures/factureInfo';
import EditFacture from './Interfaces/MFactures/editFacture';

import MesFond from "./Interfaces/MFond/mesFond";
import FondInfo from './Interfaces/MFond/FondInfo';
import EditFond from './Interfaces/MFond/editFond';
//Client
import ClientsPage from "./Interfaces/Clients/client";
import ClientPointage from './Interfaces/Clients/clientPointage';
import ClientMap from './Interfaces/Clients/clientMap';
import ClientList from './Interfaces/Clients/clientList';
import AddClient from './Interfaces/Clients/addClient';
//Stock
import Stock from "./Interfaces/Stock/stockPage";

//Recette
import Recette from "./Interfaces/Recette/recette";

//ventes
import VentePage from "./Interfaces/Ventes/ventePage";

import InputLoginPage from './Interfaces/loginPage'
import InputLandingPage from './Interfaces/camionLandingPage'

import ArticleInfo from './Interfaces/Stock/ArticleInfo';
import ReglemmentStock from './Interfaces/Stock/reglemmentStock';
import StockList from './Interfaces/Stock/stockList';
import StockFondsData from './Interfaces/Stock/inventaireData';
import StockFonds from './Interfaces/Stock/InventairePage';
import RechercheVente from './Interfaces/Ventes/recherche';
import VenteJournier from './Interfaces/Ventes/venteJournier';
import DepenseRecette from './Interfaces/Recette/ajouterDepense';
import ImprimerRecette from './Interfaces/Recette/imprimerRecette';
import UploadeCamionPage from './Interfaces/Upload/updatePage';
import AncienReglemmentStock from './Interfaces/Stock/ancienReglemmentStock';
 
import CamionClientData from './Interfaces/Clients/clientData';
import CamionCommandesListe from './Interfaces/Commander/commandesListe';
import CamionCommandesMap from './Interfaces/Commander/commandeMap';

import PrintStock from './Printing/System/tools/toolsPrintStock';
import FactureCamion from './Printing/Camion/factureCamion';
import RecetteCamionTemp from './Printing/Camion/recetteCamion';

import { Button } from 'semantic-ui-react';


function App() {
 
  const [progress, setProgress] = useState(2)

  //useefeects
  useEffect(() => {
    setProgress(100);
  }, []);

  //card
  const RedirectingPage = () => {
    const CamionIsLogged = localStorage.getItem(`${GConf.SystemTag}_Camion_LocalD`);
      return (<>
          {
              CamionIsLogged ? <Navigate to='/I'  /> : <Navigate to='/logIn'  />
          } 
  </>);}

const NotFound = () =>{
    return (<div className="cpntainer text-danger pt-5 text-center">
            <h1>Page Introuvable 404 </h1>
            <Button onClick={() =>  window.location.href = "/I"}>Page d'acuile </Button>
        </div>);
  }
  
  return (
    <>
      <Router>
        <Routes>
           <Route path="" exact element={<RedirectingPage />} />
            <Route path="logIn" exact element={<InputLoginPage />} />
            <Route path="I" exact element={<Outlet />} >
                    <Route path="" exact element={<InputLandingPage />} />
                    <Route path="nv" exact element={<NouveauxFacture />} />
                    <Route path="mf" exact element={<Outlet />} >
                        <Route path="" exact element={<MesFactures />} />
                        <Route path="info/:FID" exact element={<FactureInfo />} />
                        <Route path="modifier/:FID" exact element={<EditFacture />} />
                    </Route>
                    <Route path="sk" exact element={<Outlet />} >
                        <Route path="" exact element={<Stock />} />
                        <Route path="List" exact element={< StockList />} />
                        <Route path="Info/:code" exact element={<ArticleInfo />} />
                        <Route path="reglemment" exact element={<ReglemmentStock />} />
                        <Route path="reglemment/ancien" exact element={<AncienReglemmentStock />} />
                        <Route path="Fonds/info/:fid" exact element={<StockFondsData />} />
                        <Route path="Fonds" exact element={<StockFonds />} />
                    </Route>
                    <Route path="vt" exact element={<Outlet />}>
                        <Route path="" exact element={<VentePage />}/>
                        <Route path="list/:code" exact element={<VenteJournier />}/>
                        <Route path="recherche" exact element={<RechercheVente />}/>
                    </Route>
                    <Route path="cl" exact element={<Outlet />} >
                        <Route path="" exact element={<ClientsPage />} />
                        <Route path="ajouter" exact element={<AddClient />} />
                        <Route path="recherche" exact element={<ClientMap />} />
                        <Route path="pointage" exact element={<ClientPointage />} />
                        <Route path="List" exact element={<ClientList />} />
                        <Route path="info/:CID" exact element={<CamionClientData />} />
                    </Route>
                    <Route path="rt" exact element={<Outlet />} >
                        <Route path="" exact element={<Recette />} />
                        <Route path="depenses" exact element={<DepenseRecette />} />
                        <Route path="imprimer" exact element={<ImprimerRecette />} />
                    </Route>
                    <Route path="cm" exact element={<CamionCommandesListe />} />
                    
                    <Route path="fond" exact element={<Outlet />} >
                        <Route path="" exact element={<CamionCommandesMap />} />
                        <Route path="list" exact element={<MesFond />} />
                        <Route path="info/:FID" exact element={<FondInfo />} />
                        <Route path="edit/:FID" exact element={<EditFond />} />
                    </Route>
                    <Route path="up" exact element={<UploadeCamionPage />} />
            </Route>
            <Route path="*" element={<NotFound />} />
            <Route path="Pr">
              <Route path="CamSys">
                  <Route path="facture/:fid" element={<FactureCamion />} />
                  <Route path="stock" element={<PrintStock />} />
                  <Route path="stock/article" element={<PrintStock />} />
                  <Route path="recette" element={<RecetteCamionTemp />} />
              </Route>
        </Route> 
        </Routes>   
      </Router>
      <LoadingBar color={GConf.themeColor} progress={progress}  
                //onLoaderFinished={() => setProgress(0)} 
      />
      <ToastContainer />
    </>
    
  );
}

export default App;
